import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import SignInPage from './pages/SignInPage';
import SignUpForm from './components/SignUpForm';
import SignUpCompletePage from './pages/SignUpCompletePage';
import SchedulePage from './pages/SchedulePage';
import BookSchedulePage from './pages/BookSchedulePage';
import ResultPage from './pages/ResultPage';
import ResultMapPage from './pages/ResultMapPage';
import ReportPage from './pages/ReportPage';
import FindCredentials from './components/FindCredentials';
// import PreReservationPage from './pages/PreReservationPage';
import MyResultPage from './pages/MyResultPage';
import MyResultMapPage from './pages/MyResultMapPage';
import HomePage from './pages/HomePage';
import Home from './pages/Home';
import Ranking from './pages/Ranking';
import Insights from './pages/Insights';
import KyTest from './pages/KyTest';
import MenuPage from './pages/MenuPage';
import MyReportPage from './pages/MyReportPage';
import HomeV3 from './pages/homev3';
import Footer from './components/Footer';

function AppContent() {
  const location = useLocation();
  
  // Footer를 표시하지 않을 경로들
  const pathsWithoutFooter = [
    '/',
    '/signup',
    '/signup-complete',
    '/schedule',
    '/schedule/book',
    '/find-credentials',
    '/homedeprecatied',
    '/insights'
  ];
  
  // 경로 패턴 확인 (result 관련 페이지들)
  const isResultPage = location.pathname.startsWith('/result/');
  
  // Footer 표시 여부 결정
  const shouldShowFooter = !pathsWithoutFooter.includes(location.pathname) && !isResultPage;
  
  return (
    <>
      <Routes>
        {/* <Route path="/" element={<PreReservationPage />} /> */}
        <Route path="/" element={<SignInPage />} />
        <Route path="/homedeprecatied" element={<HomePage />} />
        {/* <Route path="/signin" element={<SignInPage />} /> */}
        <Route path="/signup" element={<SignUpForm />} />
        <Route path="/signup-complete" element={<SignUpCompletePage />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/schedule/book" element={<BookSchedulePage />} />
        <Route path="/result/:code" element={<ResultPage />} />
        <Route path="/result/:code/map" element={<ResultMapPage />} />
        <Route path="/result/:code/report" element={<ReportPage />} />
        <Route path="/find-credentials" element={<FindCredentials />} />
        <Route path="/myresult/:code" element={<MyResultPage />} />
        <Route path="/myresult/:code/map" element={<MyResultMapPage />} />
        {/* <Route path="/home" element={<Home />} /> */} // v2 홈화면
        <Route path="/ranking" element={<Ranking />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/kytest" element={<KyTest />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/myresult/:code/report" element={<MyReportPage />} />
        <Route path="/home" element={<HomeV3 />} />
      </Routes>
      {shouldShowFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <div 
      style={{ 
        minHeight: '100vh',
        background: '#ffffff',
        position: 'relative'
      }}
    >
      {/* iOS Safe Area Top Background */}
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: 'env(safe-area-inset-top, 0px)',
          background: 'rgba(255, 255, 255, 0.95)',
          zIndex: 100
        }}
      />
      <Router>
        <AppContent />
      </Router>
    </div>
  );
}

export default App;
